(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9335],{

/***/ 81382:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(3734);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var SeoTags = function(props) {
    if (!(props === null || props === void 0 ? void 0 : props.config)) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            props.config.title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: props.config.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: props.config.title
                    })
                ]
            }) : null,
            props.config.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: props.config.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: props.config.description
                    })
                ]
            }) : null,
            props.config.keywords ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.config.keywords
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "//casehub.pro/og.png"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SeoTags);


/***/ }),

/***/ 64345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ol": function() { return /* binding */ CardHeader; },
/* harmony export */   "SZ": function() { return /* binding */ CardDescription; },
/* harmony export */   "Zb": function() { return /* binding */ Card; },
/* harmony export */   "aY": function() { return /* binding */ CardContent; },
/* harmony export */   "eW": function() { return /* binding */ CardFooter; },
/* harmony export */   "ll": function() { return /* binding */ CardTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74183);





var Card = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("rounded-lg border bg-card text-card-foreground shadow-sm", className)
    }, props));
});
Card.displayName = "Card";
var CardHeader = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("flex flex-col space-y-1.5 p-6", className)
    }, props));
});
CardHeader.displayName = "CardHeader";
var CardTitle = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("text-2xl font-semibold leading-none tracking-tight", className)
    }, props));
});
CardTitle.displayName = "CardTitle";
var CardDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("text-sm text-muted-foreground", className)
    }, props));
});
CardDescription.displayName = "CardDescription";
var CardContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("p-6 pt-0", className)
    }, props));
});
CardContent.displayName = "CardContent";
var CardFooter = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)(" flex items-center p-6 pt-0", className)
    }, props));
});
CardFooter.displayName = "CardFooter";



/***/ }),

/***/ 27946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NI": function() { return /* binding */ FormControl; },
/* harmony export */   "Wi": function() { return /* binding */ FormField; },
/* harmony export */   "l0": function() { return /* binding */ Form; },
/* harmony export */   "lX": function() { return /* binding */ FormLabel; },
/* harmony export */   "pf": function() { return /* binding */ FormDescription; },
/* harmony export */   "xJ": function() { return /* binding */ FormItem; },
/* harmony export */   "zG": function() { return /* binding */ FormMessage; }
/* harmony export */ });
/* unused harmony export useFormField */
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88426);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74183);
/* harmony import */ var _components_ui_label__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93223);










var Form = react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .FormProvider */ .RV;
var FormFieldContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({});
var FormField = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormFieldContext.Provider, {
        value: {
            name: props.name
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .Controller */ .Qr, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props))
    });
};
var useFormField = function() {
    var fieldContext = react__WEBPACK_IMPORTED_MODULE_1__.useContext(FormFieldContext);
    var itemContext = react__WEBPACK_IMPORTED_MODULE_1__.useContext(FormItemContext);
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .useFormContext */ .Gc)(), getFieldState = ref.getFieldState, formState = ref.formState;
    var fieldState = getFieldState(fieldContext.name, formState);
    if (!fieldContext) {
        throw new Error("useFormField should be used within <FormField>");
    }
    var id = itemContext.id;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: id,
        name: fieldContext.name,
        formItemId: "".concat(id, "-form-item"),
        formDescriptionId: "".concat(id, "-form-item-description"),
        formMessageId: "".concat(id, "-form-item-message")
    }, fieldState);
};
var FormItemContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({});
var FormItem = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    var id = react__WEBPACK_IMPORTED_MODULE_1__.useId();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormItemContext.Provider, {
        value: {
            id: id
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            ref: ref,
            className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_7__.cn)("space-y-2", className)
        }, props))
    });
});
FormItem.displayName = "FormItem";
var FormLabel = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    var _$ref = useFormField(), error = _$ref.error, formItemId = _$ref.formItemId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_label__WEBPACK_IMPORTED_MODULE_2__/* .Label */ ._, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_7__.cn)(error && "text-destructive", className),
        htmlFor: formItemId
    }, props));
});
FormLabel.displayName = "FormLabel";
var FormControl = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    var _$ref = useFormField(), error = _$ref.error, formItemId = _$ref.formItemId, formDescriptionId = _$ref.formDescriptionId, formMessageId = _$ref.formMessageId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_8__/* .Slot */ .g7, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        id: formItemId,
        "aria-describedby": !error ? "".concat(formDescriptionId) : "".concat(formDescriptionId, " ").concat(formMessageId),
        "aria-invalid": !!error
    }, props));
});
FormControl.displayName = "FormControl";
var FormDescription = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    var formDescriptionId = useFormField().formDescriptionId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        id: formDescriptionId,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_7__.cn)("text-sm text-muted-foreground", className)
    }, props));
});
FormDescription.displayName = "FormDescription";
var FormMessage = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    var _$ref = useFormField(), error = _$ref.error, formMessageId = _$ref.formMessageId;
    var body = error ? String(error === null || error === void 0 ? void 0 : error.message) : children;
    if (!body) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        id: formMessageId,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_7__.cn)("text-sm font-medium text-destructive", className)
    }, props), {
        children: body
    }));
});
FormMessage.displayName = "FormMessage";



/***/ }),

/***/ 72685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74183);
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43936);







var Input = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, type = _param.type, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "type"
    ]);
    var _$ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), showPassword = _$ref[0], setShowPassword = _$ref[1];
    var togglePasswordVisibility = function() {
        setShowPassword(!showPassword);
    };
    var inputType = type === "password" && showPassword ? "text" : type;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                type: inputType,
                className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_6__.cn)("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pr-10", className),
                ref: ref
            }, props)),
            type === "password" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                className: "absolute right-3 top-1/2 -translate-y-1/2",
                onClick: togglePasswordVisibility,
                children: showPassword ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_2__/* .Icons.eye */ .P.eye, {
                    className: "h-4 w-4 text-gray-500"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_2__/* .Icons.eyeOff */ .P.eyeOff, {
                    className: "h-4 w-4 text-gray-500"
                })
            })
        ]
    });
});
Input.displayName = "Input";



/***/ }),

/***/ 93223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ Label; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _radix_ui_react_label__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49102);
/* harmony import */ var class_variance_authority__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12003);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74183);
"use client";







var labelVariants = (0,class_variance_authority__WEBPACK_IMPORTED_MODULE_2__/* .cva */ .j)("text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70");
var Label = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_label__WEBPACK_IMPORTED_MODULE_4__/* .Root */ .f, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_6__.cn)(labelVariants(), className)
    }, props));
});
Label.displayName = _radix_ui_react_label__WEBPACK_IMPORTED_MODULE_4__/* .Root.displayName */ .f.displayName;



/***/ }),

/***/ 61784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Textarea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74183);





var Textarea = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        className: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_4__.cn)("flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50", className),
        ref: ref
    }, props));
});
Textarea.displayName = "Textarea";



/***/ }),

/***/ 3734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./util/util.ts + 4 modules
var util = __webpack_require__(94811);
;// CONCATENATED MODULE: ./util/contact.ts

function sendContactForm(param) {
    var name = param.name, email = param.email, phone = param.phone, content = param.content;
    return (0,util/* apiRequest */.Nv)({
        path: "/ch/contact",
        method: "POST",
        data: {
            name: name,
            email: email,
            phone: phone,
            content: content
        },
        ctx: undefined
    });
}

;// CONCATENATED MODULE: ./util/hooks/useTimeout.ts

var useTimeout = function(timeInMs) {
    var ref = (0,react.useState)(false), isActive = ref[0], setIsActive = ref[1];
    (0,react.useEffect)(function() {
        var timeout = null;
        if (isActive) {
            timeout = setTimeout(function() {
                setIsActive(false);
            }, timeInMs);
        }
        return function() {
            if (timeout !== null) {
                clearTimeout(timeout);
                timeout = null;
            }
        };
    }, [
        isActive,
        setIsActive,
        timeInMs
    ]);
    var start = (0,react.useCallback)(function() {
        return setIsActive(true);
    }, [
        setIsActive
    ]);
    return [
        isActive,
        start
    ];
};

// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(56312);
// EXTERNAL MODULE: ./components/ui/form.tsx
var ui_form = __webpack_require__(27946);
// EXTERNAL MODULE: ./components/ui/input.tsx
var input = __webpack_require__(72685);
// EXTERNAL MODULE: ./components/ui/textarea.tsx
var ui_textarea = __webpack_require__(61784);
// EXTERNAL MODULE: ./components/ui/use-toast.ts
var use_toast = __webpack_require__(5271);
;// CONCATENATED MODULE: ./components/forms/ContactForm.tsx














var formSchema = lib/* object */.Ry({
    name: lib/* string */.Z_({
        required_error: "Please enter your name"
    }).min(3, {
        message: "Please enter your name"
    }),
    email: lib/* string */.Z_({
        required_error: "Please enter your email address"
    }).email(),
    phone: lib/* string */.Z_().max(30).min(4),
    content: lib/* string */.Z_({
        required_error: "Please enter your message"
    }).min(10, {
        message: "Please enter your message"
    }).max(5000, {
        message: "Message is too long"
    })
});
var ContactForm = function(props) {
    var form = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod/* zodResolver */.F)(formSchema),
        defaultValues: {}
    });
    var ref = (0,_sliced_to_array/* default */.Z)(useTimeout(3000), 2), isTimeoutActive = ref[0], startTimeout = ref[1];
    var onSubmit = function(values) {
        if (isTimeoutActive) {
            return;
        }
        startTimeout();
        (0,use_toast/* toast */.Am)({
            title: "Message sent",
            description: "We've received your message and will get back to you shortly."
        });
        // TODO reset form https://github.com/shadcn/ui/issues/549
        // form.reset({});
        sendContactForm(values).then(function(response) {
            if ((response === null || response === void 0 ? void 0 : response.status) !== "SUCCESS") {
                (0,use_toast/* toast */.Am)({
                    title: "Something went wrong",
                    description: "Please try again later."
                });
                return;
            }
            (0,use_toast/* toast */.Am)({
                title: "Message sent",
                description: "We've received your message and will get back to you shortly."
            });
            form.reset();
        }).catch(function() {
            (0,use_toast/* toast */.Am)({
                title: "Something went wrong",
                description: "Please try again later."
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* Form */.l0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            id: props.formId,
            onSubmit: form.handleSubmit(onSubmit),
            className: "space-y-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormField */.Wi, {
                    control: form.control,
                    name: "name",
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_form/* FormItem */.xJ, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormLabel */.lX, {
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormControl */.NI, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, (0,_object_spread/* default */.Z)({}, field))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormMessage */.zG, {})
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormField */.Wi, {
                    control: form.control,
                    name: "email",
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_form/* FormItem */.xJ, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormLabel */.lX, {
                                    children: "Email"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormControl */.NI, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, (0,_object_spread/* default */.Z)({}, field))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormMessage */.zG, {})
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormField */.Wi, {
                    control: form.control,
                    name: "phone",
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_form/* FormItem */.xJ, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormLabel */.lX, {
                                    children: "Phone"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormControl */.NI, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, (0,_object_spread/* default */.Z)({}, field))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormMessage */.zG, {})
                            ]
                        });
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormField */.Wi, {
                    control: form.control,
                    name: "content",
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_form/* FormItem */.xJ, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormLabel */.lX, {
                                    children: "Description"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormControl */.NI, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_textarea/* Textarea */.g, (0,_object_spread/* default */.Z)({
                                        placeholder: "Your message"
                                    }, field))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_form/* FormMessage */.zG, {})
                            ]
                        });
                    }
                })
            ]
        })
    }));
};
/* harmony default export */ var forms_ContactForm = (ContactForm);

// EXTERNAL MODULE: ./components/SeoTags.tsx
var SeoTags = __webpack_require__(47460);
// EXTERNAL MODULE: ./components/ui/card.tsx
var card = __webpack_require__(64345);
// EXTERNAL MODULE: ./components/ui/button.tsx
var ui_button = __webpack_require__(35739);
;// CONCATENATED MODULE: ./pages/contact.tsx






function ContactPage() {
    var content = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).content;
    var formId = react.useId();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoTags/* default */.Z, {
                config: content === null || content === void 0 ? void 0 : content.seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-center my-16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* Card */.Zb, {
                    className: "w-full max-w-screen sm:w-1/2 lg:w-1/3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* CardHeader */.Ol, {
                            className: "space-y-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* CardTitle */.ll, {
                                    className: "text-2xl",
                                    children: "Contact us"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* CardDescription */.SZ, {
                                    children: "We will respond to your message as soon as possible."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* CardContent */.aY, {
                            className: "grid gap-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(forms_ContactForm, {
                                formId: formId
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* CardFooter */.eW, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* Button */.z, {
                                className: "w-full",
                                form: formId,
                                type: "submit",
                                children: "Send"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var contact = (ContactPage);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7763,9774,2888,179], function() { return __webpack_exec__(81382); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);